module.exports = __webpack_public_path__ + "img/click_tab4_mobile.c1f38d46.png";